import {createStore} from 'vuex'
export default createStore({
    state: {
        //系统名称
        systemName:'资产运营管理平台',
        //系统logo
        systemLogo:'',
        //接口请求配置
        //apiServiceUrl: 'http://49.232.165.122:31001',
        //apiServiceUrl: 'http://182.40.104.194:13003/prod-api',
        apiServiceUrl: 'https://assettj.sevenleaf.com.cn/prod-api',
        //文件显示请求地址
        //fileUrl: 'http://182.40.104.194:13003/',
        //fileUrl: 'http://49.232.165.122:31004/ucd-oss-publ/',
        fileUrl: 'https://assettj.sevenleaf.com.cn/',
        //文件上传请求地址
        //uploadFileUrl: 'http://49.232.165.122:31001/common/uploadFileKeepPublic',
        //uploadFileUrl: 'http://182.40.104.194:13003/common/uploadFileKeepPublic',
        uploadFileUrl: 'https://assettj.sevenleaf.com.cn/prod-api/common/uploadFileKeepPublic',
        //用于计算请求头参数
        requestKey:'4de173c5c6d7a52b131548af30797eb9',
        //用户控制左侧菜单的显隐
        sidebarStatus:false,
        //记录点击过的下单--最多记录6个
        activeMenuList:[],
        activeMenuId:'',
        //table表头样式
        tableHeaderCss: {
            color: '#1e1e1e',
            backgroundColor: 'var(--zl-table-header-bg-color) !important',
            borderColor: 'var(--zl-table-border-color) !important',
            padding: '6px 0px',
            fontWeight: 'normal !important'
        },
        tableCellCss: {
            borderColor: 'var(--zl-table-border-color) !important',
            padding: '5px 0px'
        }
    },
    mutations: {
        changeSidebarStatus:function(state,res){
            state.sidebarStatus = res;
        },
        commitSetMenu:function(state,res){
            state.activeMenuId = res.id;
            if(state.activeMenuList.indexOf(res) < 0){
                state.activeMenuList.push(res);
                if(state.activeMenuList.length >= 7){
                    state.activeMenuList.splice(0,1);
                }
            }
        },
        commitClearMenu:function (state){
            state.activeMenuList =[];
            state.activeMenuId ='';
            state.sidebarStatus = false;
        }
    },
    actions: {},
    modules: {}
})
